import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { projectKey } from 'shared/constants'
import { usePoll } from 'shared/hooks/usePoll'

import { getTopSlots } from 'features/slots/actions'

const TopSlotsPolling: React.FC = () => {
  const dispatch = useDispatch()

  const handleGetTopSlots = useCallback(async () => {
    dispatch(getTopSlots(projectKey))
  }, [dispatch])

  usePoll(handleGetTopSlots, { delay: 3 * 60 })

  return null
}

export default TopSlotsPolling
